__turbopack_context__.v({
  "copiedMessage": "ClipboardCopy-module-scss-module__VuDSJG__copiedMessage",
  "copyButton": "ClipboardCopy-module-scss-module__VuDSJG__copyButton",
  "productCode": "ClipboardCopy-module-scss-module__VuDSJG__productCode",
  "productCodeOutOfStock": "ClipboardCopy-module-scss-module__VuDSJG__productCodeOutOfStock",
});
